// extracted by mini-css-extract-plugin
export default {"headerLink":"HeaderLink-module--headerLink--jOGPr"};